module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_vm._m(0), _vm._v(" "), _c('router-view', {
    staticClass: "right-content",
    staticStyle: {
      "position": "fixed",
      "top": "181px",
      "left": "240px",
      "right": "0",
      "bottom": "0",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secInfo"
  }, [_c('div', [_c('b', [_vm._v("订单详情")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c3d22a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/order.vue
// module id = 960
// module chunks = 2